<template>
  <div class="widget-column widget-column-left gainers-losers">
    <div class="title-section">
      <div class="title">Markets Top 5</div>
      <div class="sub-title">Gaining, Losing, and most active stocks for the day.</div>
    </div>
    <div class="tradingview-widget-container">
      <div class="tradingview-widget-container__widget" ref="topGainerLosers"></div>
      <div class="tradingview-widget-copyright">
        <a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank"><span class="blue-text">Track all markets on TradingView</span></a>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  mounted() {
    this.$nextTick(() => {
      this.loadTradingViewWidget();
    });
  },
  methods: {
    loadTradingViewWidget() {
      if (this.$refs.topGainerLosers) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-hotlists.js';
        script.innerHTML = JSON.stringify({
          colorTheme: 'light',
          dateRange: '12M',
          exchange: 'BSE',
          showChart: true,
          locale: 'in',
          height: '550',
        });
        this.$refs.topGainerLosers.appendChild(script);
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.widget-column {
  margin-bottom: 30px;

  @media (max-width: 1170px) {
    margin-bottom: 70px;
  }
}

.title-section {
  padding: 0px 5px 10px 5px;

  .title {
    font-size: 15px;
    font-weight: 700;
    color: #333;
  }

  .sub-title {
    font-size: 12px;
    font-weight: 500;
    color: #000;
  }
}

.tradingview-widget-container {
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 30px;
}

@media (max-width: 768px) {
  .title-section {
    .title {
      font-size: 14px;
    }

    .sub-title {
      font-size: 11px;
    }
  }
}
</style>
